module.exports = __webpack_public_path__ + "static/media/diagram_delcote_delglaze.fb42bebb.png";